"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenRefreshInterval = exports.tokenExpiresIn = exports.secret = void 0;
// signing key used for signing the data we put into LocalStorage
exports.secret = 'a;woi#ehf:h23hfAsd3lfkj!a@l';
exports.tokenExpiresIn = '90m';
exports.tokenRefreshInterval = 60000 * 5; // five minutes to token refresh
